import { AxiosResponse } from 'axios';

import { Users } from '../pages/tech-support/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessGetDetailUsers extends ResponseREST {
	data: Array<Users>;
}

export const getDetailUsers = async (
	id: number,
): Promise<ResponseSuccessGetDetailUsers> => {
	return axiosInstance
		.get(`get-detail-user/${id}`)
		.then((res: AxiosResponse<ResponseSuccessGetDetailUsers>) => res.data)
		.catch((err) => err);
};
